import { Close } from '@mui/icons-material'
import { Checkbox, IconButton, ListItem, ListItemText, Stack } from '@mui/material'
import { FC } from 'react'

interface Props {
  primary: string
  secondary?: string
  checked: boolean
  onToggleChecked: () => void
  onRemove: () => void
  removeLabel: string
  toggleLabel: string
}

export const AccumulatorRow: FC<Props> = ({
  primary,
  secondary,
  checked,
  onToggleChecked,
  onRemove,
  removeLabel,
  toggleLabel,
}) => {
  return (
    <ListItem
      disablePadding
      secondaryAction={
        <IconButton edge='end' size='small' aria-label={removeLabel} onClick={onRemove}>
          <Close fontSize='small' />
        </IconButton>
      }
    >
      <Stack direction='row' alignItems='center' spacing={1} sx={{ width: '100%', pr: 1 }}>
        <Checkbox
          edge='start'
          checked={checked}
          onChange={onToggleChecked}
          inputProps={{ 'aria-label': toggleLabel }}
        />
        <ListItemText primary={primary} secondary={secondary} />
      </Stack>
    </ListItem>
  )
}
